import { api, formatCount, formatTime } from '../api';
import { useLoad } from '../hooks';
import { ErrorPanel, Loading, PageHeader, StatCard } from '../components/Common';

export function DashboardPage() {
  const state = useLoad(() => api<any>('/dashboard?days=7'), []);
  if (state.loading) return <><PageHeader title="仪表盘" /><Loading /></>;
  if (state.error || !state.data) return <><PageHeader title="仪表盘" /><ErrorPanel message={state.error} onRetry={state.reload} /></>;
  const data = state.data;
  return <>
    <PageHeader title="仪表盘" description="设备、授权状态和最近 7 天任务提交概览" actions={<button onClick={state.reload}>刷新</button>} />
    <section className="stats-grid">
      <StatCard label="设备总数" value={formatCount(data.devices?.total)} detail={`待审批 ${formatCount(data.devices?.pending)}`} />
      <StatCard label="有效授权" value={formatCount(data.licenses?.active)} detail={`过期 ${formatCount(data.licenses?.expired)}`} />
      <StatCard label="7 天任务" value={formatCount(data.usage?.total)} detail={`图片 ${formatCount(data.usage?.images)} · 视频 ${formatCount(data.usage?.videos)}`} />
      <StatCard label="停用/撤销" value={formatCount(Number(data.licenses?.disabled || 0) + Number(data.licenses?.revoked || 0))} detail="需要重点关注" />
    </section>
    <section className="two-column">
      <div className="panel"><div className="panel-title"><h2>每日提交趋势</h2></div>
        <div className="trend-list">{(data.trend || []).map((row: any) => <div className="trend-row" key={row.day}>
          <span>{row.day}</span><div className="trend-bar"><i style={{ width: `${Math.min(100, Math.max(2, Number(row.total || 0) / Math.max(1, ...data.trend.map((x: any) => Number(x.total || 0))) * 100))}%` }} /></div>
          <strong>{formatCount(row.total)}</strong><small>图 {formatCount(row.images)} / 视 {formatCount(row.videos)}</small>
        </div>)}</div>
      </div>
      <div className="panel"><div className="panel-title"><h2>最近管理操作</h2></div>
        <div className="activity-list">{(data.recentAudit || []).map((row: any) => <div key={row.id} className="activity-row">
          <strong>{row.action}</strong><span>{row.actor}</span><small>{row.targetType} · {row.targetId}</small><time>{formatTime(row.createdAt)}</time>
        </div>)}</div>
      </div>
    </section>
  </>;
}
